import { useTranslations } from 'next-intl';

import { createStepComponent } from '@flipster/react/misc/step/Steps';
import { useSteps } from '@flipster/react/misc/step/use-steps';

import { ModalErrorBoundary } from '../../utils/modal-error-boundary';
import { MovableModal } from '../movable-modal';
import PnlSettingContent from '../pnl-setting-modal/pnl-setting-content';
import PnlContent from './pnl-content';
import { PnlModalContext } from './state';

type PnlSteps = {
  display: undefined;
  setting: undefined;
};
const Steps = createStepComponent<PnlSteps>();

interface Props {
  symbol: string;
  positionId: string;
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
}

const PnlModal = ({ symbol, positionId, isOpen, onClose, onExit }: Props) => {
  const t = useTranslations();

  const { current, push } = useSteps<PnlSteps>({
    initialValue: {
      step: 'display',
      context: undefined,
    },
  });

  return (
    <PnlModalContext value={{ symbol, positionId }}>
      <MovableModal.Root isOpen={isOpen} onExit={onExit} onClose={onClose}>
        <MovableModal.Header>
          <MovableModal.Title
            label={
              current.step === 'display'
                ? t('Autogen_common.r251126.s_PnL')
                : t('Autogen_common.r251126.s_Set_PnL_display')
            }
          />
        </MovableModal.Header>
        <ModalErrorBoundary onError={onClose}>
          <Steps model={current}>
            <Steps.Step step='display'>
              {() => (
                <PnlContent
                  onClose={onClose}
                  symbol={symbol}
                  onClickNext={() => push({ step: 'setting', context: undefined })}
                />
              )}
            </Steps.Step>
            <Steps.Step step='setting'>
              {() => (
                <PnlSettingContent onClose={onClose} onBack={() => push({ step: 'display', context: undefined })} />
              )}
            </Steps.Step>
          </Steps>
        </ModalErrorBoundary>
      </MovableModal.Root>
    </PnlModalContext>
  );
};

export default PnlModal;
